import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Core2Config } from '../shared/core2Config';
import { InventoryPdgUniqueCategoryCombinationLineContainerModel } from '../../../../../models/aggregates/inventory-pdg-unique-category-combination-line';
import { BaseApiPublicLoginTemplateService } from '../shared/base-api-public-login-template.service';

@Injectable({
  providedIn: 'root'
})
export class InventoryPdgUniqueCategoryCombinationLineService extends BaseApiPublicLoginTemplateService<InventoryPdgUniqueCategoryCombinationLineContainerModel,InventoryPdgUniqueCategoryCombinationLineContainerModel,InventoryPdgUniqueCategoryCombinationLineContainerModel> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.INV_PREFIX + 'pdg-unique-category-combination-lines/' + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.INV_PREFIX + 'pdg-unique-category-combination-lines/' + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.httpClient = http;
  }
}